import { IPaymentStatus, IReservation, IReservationDetail } from '../../models'

export enum ReservationsTypeKeys {
  FETCH_RESERVATIONS = 'FETCH_RESERVATIONS',
  FETCHING_RESERVATIONS = 'FETCHING_RESERVATIONS',
  FETCH_RESERVATIONS_SUCCESSFUL = 'FETCH_RESERVATIONS_SUCCESSFUL',
  FETCH_MORE_RESERVATIONS = 'FETCH_MORE_RESERVATIONS',
  FETCHING_MORE_RESERVATIONS = 'FETCHING_MORE_RESERVATIONS',
  FETCH_MORE_RESERVATIONS_SUCCESSFUL = 'FETCH_MORE_RESERVATIONS_SUCCESSFUL',
  UPDATE_RESERVATION_FAVORITE_FLAG = 'UPDATE_RESERVATION_FAVORITE_FLAG',
  FETCH_PAST_RESERVATIONS = 'FETCH_PAST_RESERVATIONS',
  FETCH_MORE_PAST_RESERVATIONS = 'FETCH_MORE_PAST_RESERVATIONS',
  FETCHING_PAST_RESERVATIONS = 'FETCHING_PAST_RESERVATIONS',
  FETCHING_MORE_PAST_RESERVATIONS = 'FETCHING_MORE_PAST_RESERVATIONS',
  FETCH_PAST_RESERVATIONS_SUCCESSFUL = 'FETCH_PAST_RESERVATIONS_SUCCESSFUL',
  FETCH_MORE_PAST_RESERVATIONS_SUCCESSFUL = 'FETCH_MORE_PAST_RESERVATIONS_SUCCESSFUL',
  FETCH_REFUNDED_RESERVATIONS = 'FETCH_REFUNDED_RESERVATIONS',
  FETCHING_REFUNDED_RESERVATIONS = 'FETCHING_REFUNDED_RESERVATIONS',
  FETCH_REFUNDED_RESERVATIONS_SUCCESSFUL = 'FETCH_REFUNDED_RESERVATIONS_SUCCESSFUL',
  FETCH_RESERVATION_DETAILS = 'FETCH_RESERVATION_DETAILS',
  FETCHING_RESERVATION_DETAILS = 'FETCHING_RESERVATION_DETAILS',
  FETCH_RESERVATION_DETAILS_SUCCESSFUL = 'FETCH_RESERVATION_DETAILS_SUCCESSFUL',
  CLEAR_RESERVATION_DETAILS = 'CLEAR_RESERVATION_DETAILS',
  DELETE_RESERVATION = 'DELETE_RESERVATION',
  DELETING_RESERVATION = 'DELETING_RESERVATION',
  DELETE_RESERVATION_SUCCESSFUL = 'DELETE_RESERVATION_SUCCESSFUL',
  SET_EXPEDITION_STATUS = 'SET_EXPEDITION_STATUS',
  SET_FULLSCREEN_MAP = 'SET_FULLSCREEN_MAP',
  SHOW_NOTIFICATION_MODAL = 'SHOW_NOTIFICATION_MODAL',
  HIDE_NOTIFICATION_MODAL = 'HIDE_NOTIFICATION_MODAL',
  SET_QR_CODE_AND_DETAILS = 'SET_QR_CODE_AND_DETAILS',
  SET_PAYMENT_NOT_DO_IT = 'SET_PAYMENT_NOT_DO_IT',
  SET_DOING_PAYMENT = 'SET_DOING_PAYMENT',
  SET_PAYMENT_SUCCESS = 'SET_PAYMENT_SUCCESS',
  SET_PAYMENT_FAILED = 'SET_PAYMENT_FAILED',
  SET_ERROR_CANCEL_RESERVATION_MODAL = 'SET_ERROR_CANCEL_RESERVATION_MODAL'
}

export interface IFetchReservationsAction {
  type: typeof ReservationsTypeKeys.FETCH_RESERVATIONS,
  payload: {
    size: number,
    page: number
  }
  [extraProps: string]: unknown
}

export interface ISetIsFetchingReservationsAction {
  type: typeof ReservationsTypeKeys.FETCHING_RESERVATIONS
  [extraProps: string]: unknown
}

export interface IFetchReservationsSuccessfulAction {
  type: typeof ReservationsTypeKeys.FETCH_RESERVATIONS_SUCCESSFUL
  payload: IReservation[]
  [extraProps: string]: unknown
}

export interface IFetchMoreReservationsAction {
  type: typeof ReservationsTypeKeys.FETCH_MORE_RESERVATIONS
  payload: {
    size: number,
    page: number
  }
  [extraProps: string]: unknown
}

export interface ISetIsFetchingMoreReservationsAction {
  type: typeof ReservationsTypeKeys.FETCHING_MORE_RESERVATIONS
  [extraProps: string]: unknown
}

export interface IFetchMoreReservationsSuccessfulAction {
  type: typeof ReservationsTypeKeys.FETCH_MORE_RESERVATIONS_SUCCESSFUL
  payload: IReservation[]
  [extraProps: string]: unknown
}

export interface IUpdateReservationFavoriteFlagAction {
  type: typeof ReservationsTypeKeys.UPDATE_RESERVATION_FAVORITE_FLAG
  payload: number
  [extraProps: string]: unknown
}

export interface IFetchPastReservationsAction {
  type: typeof ReservationsTypeKeys.FETCH_PAST_RESERVATIONS,
  payload: {
    size: number,
    page: number
  }
  [extraProps: string]: unknown
}
export interface ISetIsFetchingPastReservationsAction {
  type: typeof ReservationsTypeKeys.FETCHING_PAST_RESERVATIONS
  [extraProps: string]: unknown
}

export interface IFetchPastReservationsSuccessfulAction {
  type: typeof ReservationsTypeKeys.FETCH_PAST_RESERVATIONS_SUCCESSFUL
  payload: IReservation[]
  [extraProps: string]: unknown
}

export interface IFetchMorePastReservationsAction {
  type: typeof ReservationsTypeKeys.FETCH_MORE_PAST_RESERVATIONS,
  payload: {
    size: number,
    page: number
  }
  [extraProps: string]: unknown
}

export interface ISetIsFetchingMorePastReservationsAction {
  type: typeof ReservationsTypeKeys.FETCHING_MORE_PAST_RESERVATIONS
  [extraProps: string]: unknown
}

export interface IFetchMorePastReservationsSuccessfulAction {
  type: typeof ReservationsTypeKeys.FETCH_MORE_PAST_RESERVATIONS_SUCCESSFUL
  payload: IReservation[]
  [extraProps: string]: unknown
}

export interface IFetchRefundedReservationsAction {
  type: typeof ReservationsTypeKeys.FETCH_REFUNDED_RESERVATIONS
}

export interface ISetIsFetchingRefundedReservationsAction {
  type: typeof ReservationsTypeKeys.FETCHING_REFUNDED_RESERVATIONS
}

export interface IFetchRefundedReservationsSuccessfulAction {
  type: typeof ReservationsTypeKeys.FETCH_REFUNDED_RESERVATIONS_SUCCESSFUL
  payload: IReservation[]
}

export interface IFetchReservationDetailsAction {
  type: typeof ReservationsTypeKeys.FETCH_RESERVATION_DETAILS
  payload: IReservationDetail
  [extraProps: string]: unknown
}

export interface ISetIsFetchingReservationDetailsAction {
  type: typeof ReservationsTypeKeys.FETCHING_RESERVATION_DETAILS
  [extraProps: string]: unknown
}

export interface IFetchReservationDetailsSuccessfulAction {
  type: typeof ReservationsTypeKeys.FETCH_RESERVATION_DETAILS_SUCCESSFUL
  payload: IReservation
  [extraProps: string]: unknown
}

export interface IClearReservationDetailsAction {
  type: typeof ReservationsTypeKeys.CLEAR_RESERVATION_DETAILS
  [extraProps: string]: unknown
}

export interface IDeleteReservationAction {
  type: typeof ReservationsTypeKeys.DELETE_RESERVATION
  payload: { id: number, comment: string }
  [extraProps: string]: unknown
}

export interface ISetIsDeletingReservationAction {
  type: typeof ReservationsTypeKeys.DELETING_RESERVATION
  [extraProps: string]: unknown
}

export interface IDeleteReservationSuccessfulAction {
  type: typeof ReservationsTypeKeys.DELETE_RESERVATION_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface ISetExpeditionStatusAction {
  type: typeof ReservationsTypeKeys.SET_EXPEDITION_STATUS
  payload: string
  [extraProps: string]: unknown
}

export interface ISetFullscreenMapAction {
  type: typeof ReservationsTypeKeys.SET_FULLSCREEN_MAP
  payload: boolean
  [extraProps: string]: unknown
}

export interface IShowNotificationModalAction {
  type: typeof ReservationsTypeKeys.SHOW_NOTIFICATION_MODAL
  payload: any
  [extraProps: string]: unknown
}

export interface IHideNotificationModalAction {
  type: typeof ReservationsTypeKeys.HIDE_NOTIFICATION_MODAL
  [extraProps: string]: unknown
}

export interface ISetQrCodeAndDetails {
  type: typeof ReservationsTypeKeys.SET_QR_CODE_AND_DETAILS
  payload: IReservation | null
  [extraProps: string]: unknown;
}

export interface ISetPaymentNotDoIt {
  type: typeof ReservationsTypeKeys.SET_PAYMENT_NOT_DO_IT
}

export interface ISetDoingPayment {
  type: typeof ReservationsTypeKeys.SET_DOING_PAYMENT,
  payload: IPaymentStatus
  [extraProps: string]: unknown;
}

export interface ISetPaymentSuccess {
  type: typeof ReservationsTypeKeys.SET_PAYMENT_SUCCESS,
  payload: IPaymentStatus
  [extraProps: string]: unknown;
}

export interface ISetPaymentFailed {
  type: typeof ReservationsTypeKeys.SET_PAYMENT_FAILED,
  payload: IPaymentStatus
  [extraProps: string]: unknown;
}

export interface ISetErrorCancelReservationModalAction {
  type: typeof ReservationsTypeKeys.SET_ERROR_CANCEL_RESERVATION_MODAL
  payload: boolean
}

export type ReservationsActionTypes =
  | IFetchReservationsAction
  | ISetIsFetchingReservationsAction
  | IFetchReservationsSuccessfulAction
  | IFetchMoreReservationsAction
  | ISetIsFetchingMoreReservationsAction
  | IFetchMoreReservationsSuccessfulAction
  | IUpdateReservationFavoriteFlagAction
  | IFetchPastReservationsAction
  | IFetchMorePastReservationsAction
  | ISetIsFetchingMorePastReservationsAction
  | IFetchMorePastReservationsSuccessfulAction
  | ISetIsFetchingPastReservationsAction
  | IFetchPastReservationsSuccessfulAction
  | IFetchRefundedReservationsAction
  | ISetIsFetchingRefundedReservationsAction
  | IFetchRefundedReservationsSuccessfulAction
  | IFetchReservationDetailsAction
  | ISetIsFetchingReservationDetailsAction
  | IFetchReservationDetailsSuccessfulAction
  | IClearReservationDetailsAction
  | IDeleteReservationAction
  | ISetIsDeletingReservationAction
  | IDeleteReservationSuccessfulAction
  | ISetExpeditionStatusAction
  | ISetFullscreenMapAction
  | IShowNotificationModalAction
  | IHideNotificationModalAction
  | ISetQrCodeAndDetails
  | ISetPaymentNotDoIt
  | ISetDoingPayment
  | ISetPaymentSuccess
  | ISetPaymentFailed
  | ISetErrorCancelReservationModalAction
